import { useRef, useState } from 'react';
import { Button } from '@optimus-web/core';
import { CurrencySelectDialog, CurrencySelectDialogProps } from './CurrencySelectDialog';
import { Currency } from './types';

interface CurrencySelectDialogButtonProps {
    currencies: Currency[];
    dataTestId: string;
    portalContainerId: string;
    selectedCurrencyCode: string;
    propertyCurrencyCode?: string;
    suggestedCurrencyCodes?: string[];
    dialogTexts: CurrencySelectDialogProps['texts'];
    buttonAriaLabel: string;
    showSearchInput?: boolean;
    onChange: (currencyCode: string) => void;
}

export const CurrencySelectDialogButton = ({
    currencies,
    dataTestId,
    portalContainerId,
    propertyCurrencyCode,
    selectedCurrencyCode,
    suggestedCurrencyCodes = [],
    buttonAriaLabel,
    dialogTexts,
    showSearchInput,
    onChange,
}: CurrencySelectDialogButtonProps) => {
    const [isDialogActive, setIsDialogActive] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const focusButton = () => buttonRef.current?.focus();

    const handleChange = (currencyCode: string) => {
        onChange(currencyCode);
        setIsDialogActive(false);
        focusButton();
    };

    const handleClose = () => {
        setIsDialogActive(false);
        focusButton();
    };

    return (
        <>
            <Button
                aria-label={buttonAriaLabel}
                data-test-id={dataTestId}
                onClick={() => setIsDialogActive(true)}
                type="button"
                size="large"
                ref={buttonRef}
            >
                {selectedCurrencyCode}
            </Button>
            <CurrencySelectDialog
                currencies={currencies}
                isActive={isDialogActive}
                onChange={handleChange}
                onClose={handleClose}
                portalContainerId={portalContainerId}
                selectedCurrencyCode={selectedCurrencyCode}
                propertyCurrencyCode={propertyCurrencyCode}
                suggestedCurrencyCodes={suggestedCurrencyCodes}
                texts={dialogTexts}
                showSearchInput={showSearchInput}
            />
        </>
    );
};
